// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('appKpisConfig/getData', async params => {

  const response = await axios.get('/apps/kpisConfig', params)

  return {
    params,
    dataOffice:                 response.data.KpisOffice,
    dataOfficeUsers:            response.data.KpisOfficeUsers,
    allDataOffice:              response.data.allData.office,
    allDataOfficeUsers:         response.data.allData.officeusers,
    totalPagesOffice:           response.data.totalOffice,
    totalPagesOfficeUsers :     response.data.totalOfficeUsers
  }
})
export const appKpisConfigSlice = createSlice({
  name: 'appKpisConfig',
  initialState: {
    dataOffice: [],
    dataOfficeUsers: [],
    totalPagesOffice: 1,
    totalPagesOfficeUsers: 1,
    params: {},
    allDataOffice: [],
    allDataOfficeUsers: []
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.dataOffice         = action.payload.dataOffice
      state.dataOfficeUsers    = action.payload.dataOfficeUsers
      state.allDataOffice      = action.payload.allDataOffice
      state.allDataOfficeUsers = action.payload.allDataOfficeUsers
      state.totalOffice        = action.payload.totalPagesOffice
      state.totalOfficeUsers   = action.payload.totalPagesOfficeUsers
      state.params             = action.payload.params
    })
  }
})

export default appKpisConfigSlice.reducer
